'use strict';

var create = function create(type, isQueued, command, actionType) {
  return Object.assign({}, { type: type, isQueued: isQueued, command: command, actionType: actionType });
};

var createImmediateCmd = function createImmediateCmd(type, command, actionType) {
  return create(type, false, command, actionType);
};

var createQueuedCmd = function createQueuedCmd(type, command, actionType) {
  return create(type, true, command, actionType);
};

module.exports.createImmediateCmd = createImmediateCmd;
module.exports.createQueuedCmd = createQueuedCmd;


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/commands.js
// module id = 285
// module chunks = 0